// extracted by mini-css-extract-plugin
module.exports = {"file":"attachment-list__file___1-Gza"};